import { gsap } from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';
import { ParticleWaveBackground } from '../lib/ParticleWaveBackground';
import { lg, xl } from '../common';

export function initBlockRedCta2(parent) {
  if (!parent) return;

  const animationBgEl = parent.querySelector('.block-red-cta2__bg');
  if (!animationBgEl) return;

  const animation = new ParticleWaveBackground(animationBgEl, {
    planeWidth: 7,
    planeHeight: 5,
    widthSegments: 120,
    heightSegments: 70,
    particleSize: 0.02,
    sizeScale: 0.7,
    waveHeight: 0.5,
    noiseScale: 2,
    animationSpeed: 6000,
    gradient: [
      { color: '#ffffffff', stop: 0 },
      { color: '#ffffffff', stop: 100 },
    ],
    rotation: { x: 30, y: 0, z: 0 },
    cameraPosition: [0, 0.2, 4.2],
    cameraRotation: { x: 0, y: 0, z: 0 },
    autoStart: false,
    hoverRadius: 1,
    hoverStrength: 0.5,
    hoverSpringStiffness: 40,
    hoverSpringDamping: 10,
    breakpoints: {
      [lg]: {
        planeWidth: 14,
        planeHeight: 5,
        particleSize: 0.025,
      },
    },
  });

  ScrollTrigger.create({
    trigger: parent,
    start: 'top bottom',
    end: 'bottom top',
    onEnter: () => animation.startAnimation(),
    onLeave: () => animation.stopAnimation(),
    onEnterBack: () => animation.startAnimation(),
    onLeaveBack: () => animation.stopAnimation(),
  });

  const tl = gsap.timeline({
    scrollTrigger: {
      trigger: parent,
      start: 'top 75%',
      toggleActions: 'play none none none',
      // markers: true,
    },
    defaults: { ease: 'power4.out' },
  });

  const heading = parent.querySelector('.block-red-cta2__heading');
  if (heading) {
    tl.fromTo(
      heading,
      {
        clipPath: 'polygon(0% 0%, 0% 0%, 0% 100%, 0% 100%)',
      },
      {
        clipPath: 'polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%)',
        duration: 1.2,
      },
    );
  }

  const text = parent.querySelector('.block-red-cta2__text');
  if (text) {
    tl.from(
      text,
      {
        y: 10,
        opacity: 0,
        duration: 1.2,
      },
      '-=0.4',
    );
  }

  const btns = parent.querySelector('.block-red-cta2__btns');
  if (btns) {
    tl.from(
      btns,
      {
        opacity: 0,
        duration: 1.2,
      },
      '-=1.0',
    );
  }

  const tip = parent.querySelector('.block-red-cta2__tip');
  if (tip) {
    tl.from(
      tip,
      {
        opacity: 0,
        duration: 1.2,
      },
      '<',
    );
  }
}

export function initAllBlockRedCta2(selector = '.js-block-red-cta2') {
  const blocks = document.querySelectorAll(selector);
  blocks.forEach((block) => initBlockRedCta2(block));
}
